<template>
  <div id="page-products" class="page-products">
    <div class="page-title-box">
      <div class="page-title-right">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }" href="#">Home</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Product Requests
            </li>
          </ol>
        </nav>
      </div>
      <div class="page-title-left">
        <h2 class="page-title">Product Requests</h2>
        <router-link
          :to="{
            name: 'website-product-requests-new',
            params: { site_id: currentWebsiteId },
          }"
          class="btn btn-primary mb-0"
        >
          <i class="mdi mdi-plus-circle mr-2"></i> Add Product Request
        </router-link>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <div class="dataTables_wrapper dt-bootstrap4 no-footer">
            <div class="top-nav-container row">
              <top-pagination
                :metadata="pagination"
                :results="product_requests"
                v-on:change="load"
                v-on:reset="reset"
                :searchText="search"
              ></top-pagination>
            </div>
            <table
              class="table table-centered w-100 dt-responsive nowrap"
              id="products-datatable"
            >
              <thead class="thead-light">
                <tr>
                  <th class="image-col">&nbsp;</th>
                  <result-table-header
                    :order.sync="order"
                    :direction.sync="direction"
                    order-key="name"
                    class="all"
                    >Product Name</result-table-header
                  >
                  <result-table-header
                    :order.sync="order"
                    :direction.sync="direction"
                    order-key="updated_at"
                    >Date</result-table-header
                  >
                  <th>State</th>
                  <th style="width: 85px;">Action</th>
                </tr>
              </thead>
              <template v-if="!loading">
                <tbody v-if="!empty">
                  <tr
                    v-for="product_request in product_requests"
                    :key="product_request.id"
                  >
                    <td class="image-col">
                      <div
                        class="image-container"
                        :style="getThumbnailUrl(product_request)"
                      ></div>
                    </td>
                    <td>
                      <a
                        href="#"
                        class="text-body file-name"
                        @click.prevent="showDetail(product_request.id)"
                        >{{ product_request.name }}</a
                      >
                    </td>
                    <td v-text="getCreatedDate(product_request)"></td>
                    <td>
                      <span
                        class="product-request-state-label"
                        :class="[getStateClass(product_request)]"
                        v-text="getStateLabel(product_request)"
                      ></span>
                    </td>

                    <td class="table-action">
                      <a
                        href="#"
                        @click.prevent="showDetail(product_request.id)"
                        class="action-icon"
                      >
                        <i class="mdi mdi-pencil"></i>
                      </a>
                      <a
                        @click.prevent="destroy(product_request.id)"
                        href="#"
                        class="action-icon"
                        :class="{
                          disabled: !product_request.is_client_delete_allowed,
                        }"
                        :title="
                          !product_request.is_client_delete_allowed
                            ? 'The request was submitted. Deletion is  not allowed.'
                            : ''
                        "
                      >
                        <i class="mdi mdi-delete"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody class="empty" v-else>
                  <tr>
                    <td colspan="5">
                      <div class="d-flex justify-content-center">
                        List is empty
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
              <tbody class="loading" v-else>
                <tr>
                  <td colspan="5">
                    <div class="d-flex justify-content-center">
                      <div class="spinner-border" role="status"></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <pagination
              :metadata="pagination"
              :results="product_requests"
              v-on:change="load"
              v-on:reset="reset"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { forEach } from "lodash";

import { EventBus } from "@/utils/EventBus";

import product_request from "@/client/api/product_request";

import TopPagination from "@/ui/TopPagination";
import Pagination from "@/ui/Pagination";
import ResultTableHeader from "@/ui/ResultTableHeader";

export default {
  components: {
    TopPagination,
    Pagination,
    ResultTableHeader,
  },
  watch: {
    $route: {
      handler: "loadFirstPage",
      immediate: true,
    },
    order: function(val, oldVal) {
      if (val && oldVal != null) {
        this.changeOrder();
      }
    },
    direction: function(val, oldVal) {
      if (val && oldVal != null) {
        this.changeOrder();
      }
    },
  },
  data() {
    return {
      product_requests: [
        /*
                {
                    id: 1,
                    name: "Product",
                    state: 1,
                    created_at: "2020-06-01T12:00Z",
                    image_url: ""
                },
                {
                    id: 2,
                    name: "Product 2",
                    state: 0,
                    created_at: "2020-06-01T12:00Z",
                    image_url: ""
                }
             */
      ],
      pagination: {},

      order: null,
      direction: null,
      empty: false,
      loading: false,
      per_page: null,
      search: null,
      timer: null,
    };
  },
  methods: {
    loadFirstPage() {
      this.load(1);
    },
    async load(page = null) {
      this.loading = true;
      let params = {
        search: this.search,
        order: this.order,
        direction: this.direction,
      };

      let res = await product_request.getProductRequests(
        this.currentWebsiteId,
        page,
        this.per_page,
        params
      );

      if (res.data) {
        if (res.data.data) {
          this.product_requests = res.data.data;
          this.empty = !this.product_requests.length;
        }

        if (res.data.meta) {
          this.pagination = res.data.meta;
        }

        if (res.data.meta && res.data.meta.order) {
          this.order = res.data.meta.order;
        } else {
          this.order = null;
        }
        if (res.data.meta && res.data.meta.direction) {
          this.direction = res.data.meta.direction;
        } else {
          this.direction = null;
        }
      }

      this.loading = false;
    },
    reset(params) {
      this.per_page = params[0];
      this.search = params[1];
      this.load(1);
    },
    getCreatedDate(product) {
      return moment(product.updated_at).format("lll");
    },
    getStateLabel(product) {
      if (product.is_processed) {
        return "Processed";
      } else if (product.is_submitted) {
        return "Submitted";
      }
      return "Draft";
    },
    getStateClass(product) {
      if (product.is_processed) {
        return "processed";
      } else if (product.is_submitted) {
        return "submitted";
      }
      return "";
    },
    getThumbnailUrl(product) {
      if (product.thumbnail_url) {
        return {
          backgroundImage: "url(" + product.thumbnail_url + ")",
        };
      }
    },
    showDetail(product_request_id) {
      this.$router.push({
        name: "website-product-requests-detail",
        params: { site_id: this.currentWebsiteId, product_request_id },
      });
    },
    changeOrder() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.load(1);
        this.timer = null;
      }, 100);
    },
    destroy(id) {
      EventBus.$emit("show-modal", "confirm-modal", {
        type: "danger",
        title: "Delete Confirmation",
        message: "Do you want to delete the request?",
        confirmLabel: "Delete",
        confirmCallback: () => {
          this.doDestroy(id);
        },
      });
    },
    async doDestroy(id) {
      let res = await product_request.deleteProductRequest(
        this.currentWebsiteId,
        id
      );

      if (res.data && res.data.status == "ok") {
        console.log(res);
        this.reloadCurrentPage();
      }
    },
    reloadCurrentPage() {
      let page = null;
      if (this.pagination && this.pagination.current_page) {
        page = this.pagination.current_page;
      }
      this.load(page);
    },
  },
  computed: {
    ...mapState(["currentWebsiteId"]),
  },
};
</script>

<style lang="scss">
.top-nav-container {
  .pagination-container {
    flex: 1;
    margin: 0;

    & > :last-child {
      padding-right: 0;
    }
  }
}

#products-datatable {
  th {
    .direction {
      margin-left: 5px;
    }
  }

  .image-col {
    width: rem-calc(64);

    .image-container {
      width: rem-calc(64);
      height: rem-calc(64);
      border-radius: rem-calc(5);
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: #efefef;
      background-image: url("../img/icon-product.png");
      overflow: hidden;

      @include retina {
        background-image: url("../img/icon-product@2x.png");
      }
    }
  }

  a.action-icon {
    &:hover {
      .mdi-delete {
        color: $alert-color;
      }
    }

    &.disabled {
      color: #efefef;
      cursor: not-allowed;

      &:hover {
        .mdi-delete {
          color: #efefef;
        }
      }
    }

    .mdi-cloud-alert {
      color: $alert-color;
    }
  }
}

.product-request-state-label {
  padding: rem-calc(2) rem-calc(6);
  border-radius: rem-calc(3);
  font-size: rem-calc(11);
  font-weight: bold;
  // line-height: rem-calc(12);
  color: white;
  background-color: $secondary-color;
  &.submitted {
    background-color: $primary-color;
  }
  &.processed {
    background-color: $success-color;
  }
}
</style>
